import { useState } from "react";
import moment from "moment";
import { Button, ListItemText, Menu, MenuItem, Snackbar } from "@mui/material";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import { CreateParamsJson } from "../../helper/pathHelper";
import { ASSISTANTS, buildEditPrompt } from "../../helper/aiPrompt";
import { appBase, copyText } from "../../helper/clipboard";
import { useLanguage } from "../../i18n/LanguageContext";

// Hands the plan on the board back to an AI assistant: the prompt lists
// the cards with their times plus the current link, so the assistant can
// change it ("30 minutes shorter", "lunch at 12:00") and answer with a new
// link.
export default function EditWithAi() {
  const json = CreateParamsJson();
  const [anchor, setAnchor] = useState(null);
  const [copied, setCopied] = useState(false);
  const { language, t } = useLanguage();

  const agenda = json.agenda ? JSON.parse(json.agenda) : [];
  if (!json.starttime || agenda.length === 0) {
    return null;
  }
  const prompt = buildEditPrompt(
    moment(json.starttime),
    agenda,
    language,
    appBase()
  );

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        className="edit-with-ai-btn"
        startIcon={<AutoAwesome />}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {t("editWithAi.button")}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: "card-menu" } }}
      >
        {ASSISTANTS.map((assistant) => (
          <MenuItem
            key={assistant.name}
            component="a"
            href={assistant.url(prompt)}
            target="_blank"
            rel="noreferrer"
            onClick={async () => {
              setAnchor(null);
              if (assistant.copyFirst) {
                setCopied(await copyText(prompt));
              }
            }}
          >
            <ListItemText
              primary={t("editWithAi.openIn", { name: assistant.name })}
              secondary={
                assistant.copyFirst
                  ? t("editWithAi.copyFirstHint")
                  : t("editWithAi.prefilledHint")
              }
            />
          </MenuItem>
        ))}
        <MenuItem
          onClick={async () => {
            setAnchor(null);
            setCopied(await copyText(prompt));
          }}
        >
          <ListItemText
            primary={t("editWithAi.copyPrompt")}
            secondary={t("editWithAi.copyPromptHint")}
          />
        </MenuItem>
      </Menu>
      <Snackbar
        open={copied}
        autoHideDuration={2500}
        onClose={() => setCopied(false)}
        message={t("editWithAi.copied")}
      />
    </>
  );
}
